<template>
  <div class="scroller">
    <slot name="title" />

    <div
      ref="carouselWrapperRef"
      class="scroller-wrapper"
    >
      <button
        v-show="isPrevVisible"
        class="primary button-icon button-icon-small prev"
        aria-label="Scroll backward"
        @click.stop="backward"
      >
        <i class="chevron-small-left-white" />
      </button>

      <div
        ref="carouselRef"
        class="scroller-carousel"
        @scroll="onScroll"
      >
        <template v-for="(item, index) in items">
          <slot
            name="item"
            :data="item"
            :index="index"
          />
        </template>
      </div>

      <button
        v-show="isForwardVisible"
        class="primary button-icon button-icon-small forward"
        aria-label="Scroll forward"
        @click.stop="forward"
      >
        <span
          class="chevron-small-right-white"
          aria-hidden="true"
        />
      </button>
    </div>

    <slot name="footer" />
  </div>
</template>

<script setup>
import useScroller from './useScroller';

const props = defineProps({
  items: {
    type: Array,
    required: false,
    default: () => [],
  },
  hasChevrons: {
    type: Boolean,
  },
  shift: {
    type: Number,
    required: false,
    validator(value) {
      return typeof value === 'number' && value > 0 && value <= 1;
    },
    default: () => 0.25,
  },
});

const {
  carouselWrapperRef,
  carouselRef,
  onScroll,
  forward,
  backward,
  isForwardVisible,
  isPrevVisible,
  align,
} = useScroller(props);

</script>

<style lang="scss" scoped>
@import "~@core/csg/src/scss/components/button-icon-mixin.scss";
@import "~@csgIcons/_chevron-small-left-white.scss";
@import "~@csgIcons/_chevron-small-right-white.scss";
@include csg-button-icon;

.scroller {
  width: 100%;
  padding: 2rem;

  @include breakpoint(small only) {
    padding: 2rem 1rem;
  }
}

.scroller-wrapper {
  position: relative;
  width: 100%;

  .prev, .forward {
    position: absolute;
    z-index: 10;
    top: calc(50% - 1rem);
  }
  .prev {
    left: 8px;
  }
  .forward {
    right: 8px;
  }
}

.treatment-padding{
  @include breakpoint(medium down) {
    padding: rem-calc(24px) 1rem;
  }
}

.scroller-carousel {
  white-space: nowrap;
  display: flex;
  overflow-x: scroll;
  scrollbar-width: none;
  overscroll-behavior-x: contain;
  &::-webkit-scrollbar{
    display: none;
  }
  justify-content: v-bind(align);
}

</style>

<style lang="scss" brand="mcom">
.scroller.treatment-padding{
  padding-inline: 12.5px;

  @include breakpoint(medium down) {
    padding-inline: 16px;
  }
}
</style>
